/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import e from"../SpatialReference.js";import{SphericalPCPFMars as i,SphericalPCPFMoon as r}from"../spatialReferenceEllipsoidUtils.js";import{equals as t,isMars as o,isMoon as p}from"./spatialReferenceUtils.js";import{SupportedGCSWkids as s}from"./SupportedGCSWkids.js";function f(f){return t(f,i)||o(f)?{wkid:s.GCSMARS2000}:t(f,r)||p(f)?{wkid:s.GCSMOON2000}:e.WGS84}export{f as getCGSForPlanet};
